import { useNavigate } from "react-router-dom";
import useCheckLogin from "../../../hook/useCheckLogin";
import { Box, Image } from "@chakra-ui/react";
import announcementIcon from "../../../components/AnnouncementModal/images/announcement_icon.png";
import { useMemo } from "react";

/**
 * @description 公告按鈕
 * @returns JSX.Element
 */
const AnnouncementButton = () => {
  const { isMachineUser } = useCheckLogin();

  const navigate = useNavigate();

  const handleNavigate = () => navigate("?announcement_open=true");

  const iconSize = useMemo(() => {
    return {
      base: "47.5px",
      md: "57.5px",
      xl: isMachineUser ? "57.5px" : "62.5px",
    };
  }, [isMachineUser]);

  return (
    <Box
      onClick={handleNavigate}
      position={"relative"}
      cursor={"pointer"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      shadow={"sm"}
    >
      <Image src={announcementIcon} height={iconSize} maxW={iconSize} />
    </Box>
  );
};

export default AnnouncementButton;
